
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias/resultado-pesquisa",
      function () {
        return require("private-next-pages/noticias/resultado-pesquisa/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias/resultado-pesquisa"])
      });
    }
  